import React, { useState } from 'react';
import classNames from 'classnames';
import capitalize from 'lodash/capitalize';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButton from '../../../../components/elements/CtaButton';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import { ValuePropItem, ValuePropsList } from '../../../../components/elements/ValuePropsList';
import { templateStringFormat } from '../../../../utils/stringUtils';

import styles from './PlanSelectorRedesign.module.css';
import SlideDownReveal from '../../../../components/elements/SlideDownReveal';
import { usePlanSelector } from './hooks';

const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/global`;

function SlideRevealValueProps({ valueProps, showInitially }) {
  const [visible, setVisible] = useState(showInitially ? 'initial' : 0);

  const toggleMobileProps = () => {
    setVisible(!visible);
  };

  return (
    <div className={styles.subscriptionPlanValuePropsMobile}>
      <SlideDownReveal in={visible}>
        <ValuePropsList className={styles.subscriptionPlanValuePropsList}>
          {valueProps && valueProps.map((valueProp, i) => {
            return (
              <ValuePropItem
                key={`valueProps_${i}`}
                alignItems="flex-start"
                iconSize="small"
                icon={`${imgURL}/checkmark-updated-blue.svg`}
              >
                <CodeSparkThemedTypography variant="body3">{valueProp}</CodeSparkThemedTypography>
              </ValuePropItem>
            );
          })}
        </ValuePropsList>
      </SlideDownReveal>

      <div className={styles.subscriptionPlanValuePropsToggle} onClick={toggleMobileProps}>
        <CodeSparkThemedTypography variant="subtitle3" Element="span">
          <span>{visible ? 'Hide details' : 'Show details'}</span>
          <span className={styles.subscriptionPlanValuePropsToggleIcon}>
            <i className={classNames('fa', visible ? 'fa-angle-up' : 'fa-angle-down')} />
          </span>
        </CodeSparkThemedTypography>
      </div>
    </div>
  );
}

function PlanValueProps({ valuePropKeys, valuePropsMapping, valueProps, showValuePropsInitially }) {

  return (
    <>
      <div className={`${styles.subscriptionPlanValuePropsDesktop}`}>
        {valuePropKeys.map(key => {
          const hasValueProp = valuePropsMapping && !!valuePropsMapping[key];
          const iconClass = hasValueProp ? 'checkmark-updated-blue' : 'errorX-pink5';

          return (
            <div
              key={key}
              className={classNames(styles.valuePropContainer, styles.subscriptionPlanValueProp)}
            >
              <div className={styles.subscriptionPlanValuePropIconContainer}>
                <img src={`${imgURL}/${iconClass}.svg`} alt={`${hasValueProp}`} />
              </div>
            </div>
          );
        })}
      </div>

      <SlideRevealValueProps valueProps={valueProps} showInitially={showValuePropsInitially} />
    </>
  );
}

const HighlightFlag = ({ children, location = 'outer' }) => {
  const locationClass = capitalize(location);
  return (
    <div
      className={classNames(
        styles.subscriptionPlanContainerHighlightFlag,
        styles[`subscriptionPlanContainerHighlightFlag${locationClass}`]
      )}
    >
      <CodeSparkThemedTypography variant="body1">{children}</CodeSparkThemedTypography>
    </div>
  );
};

export default function SubscriptionPlan(planData) {
  const {
    onCtaClick,
    eyebrow,
    title,
    priceDisplay,
    percentChange,
    percentChangeOverride,
    billingLegal,
    ctaLabel,
    valuePropsMapping,
    valuePropKeys,
    highlightText,
    valueProps,
    showValuePropsInitially,
    planId,
    plan,
  } = planData;
  const percentSavings = percentChangeOverride ? percentChangeOverride : percentChange;
  const formatedCtaLabel = templateStringFormat(ctaLabel, plan);

  const { handleSelectPlan } = usePlanSelector({ onCtaClick });

  return (
    <div
      className={classNames(
        'flex-container flex-dir-column align-middle',
        styles.planSelectorColumnSizing,
        styles.subscriptionPlanSpacing
      )}
    >
      {highlightText && <HighlightFlag location="outer">{highlightText}</HighlightFlag>}
      <div
        className={classNames(
          styles.planSelectorColumn,
          styles.subscriptionPlanContainer,
          highlightText && styles.subscriptionPlanContainerHighlight
        )}
      >
        {highlightText && <HighlightFlag location="inner">{highlightText}</HighlightFlag>}

        <CodeSparkThemedTypography variant="body3" className={styles.subscriptionPlanEyebrow}>
          {eyebrow}
        </CodeSparkThemedTypography>

        <CodeSparkThemedTypography
          variant="h3"
          align="center"
          className={styles.subscriptionPlanTitle}
          parseText
        >
          {title}
        </CodeSparkThemedTypography>

        <div className={styles.subscriptionPlanPricing}>
          <CodeSparkThemedTypography variant="subtitle2">{priceDisplay}</CodeSparkThemedTypography>

          {percentSavings && (
            <CodeSparkThemedTypography
              variant="subtitle3"
              Element="span"
              className={styles.subscriptionPlanPricingSavings}
            >
              Save {percentSavings}
            </CodeSparkThemedTypography>
          )}
        </div>

        <CodeSparkThemedTypography variant="body3" className={styles.subscriptionPlanBilling}>
          {billingLegal}
        </CodeSparkThemedTypography>

        <CtaButtonContainer className={styles.subscriptionPlanCtaContainer} fullWidth>
          <CtaButton type="primary2" onClick={e => handleSelectPlan(e, planId)} fullWidth>
            {formatedCtaLabel}
          </CtaButton>
        </CtaButtonContainer>

        <PlanValueProps
          valuePropsMapping={valuePropsMapping}
          valuePropKeys={valuePropKeys}
          valueProps={valueProps}
          showValuePropsInitially={showValuePropsInitially}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/SubscriptionPlanRedesign.js